<!-- routify:options preload="proximity" -->
<script lang="ts">
  window["C"].APP_NAME = "no_auth_app";

  import GoogleTranslate from "@modern/components/shared/GoogleTranslate.svelte";
  import bootstrap from "@modern/services/boot/bootstrap";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { afterPageLoad, beforeUrlChange, page, url, goto } from "@roxi/routify";
  import Header from "@modern/components/no_auth/Header.svelte";
  import Footer from "@shared/svelte/Components/Layout/Footer.svelte";
  import { updatePageIds } from "@shared/services/event_tracking/page_id_tracking";

  const { trackPageView } = EventTracking;

  $afterPageLoad(page => {
    trackPageView();
    return true;
  });

  $beforeUrlChange((event, route) => {
    updatePageIds();
    return true;
  });

  const load = async () => {
    updatePageIds();
    await bootstrap({ $page, $url, $goto });
  };

</script>

{#await load()}
  <Spinner />
{:then}
  <div class="app-container">
    <Header />
    <slot />
    <Footer />
    <GoogleTranslate />
  </div>
{/await}
